export { default } from './Shell';



// WEBPACK FOOTER //
// ./src/core/Shell/index.ts